var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-toggle',{staticClass:"_favorite",attrs:{"icon-href":"#favorite","active":_vm.active,"size":_vm.size,"title-active":"В избранном","title-inactive":"Добавить в избранное","isFavorite":"true"},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }